import dayjs from "dayjs";

export function formatDate(date, format = "YYYY-MM-DD HH:mm:ss") {
  // 日期不存在，则返回空
  if (!date) {
    return "";
  }
  // 日期存在，则进行格式化
  return date ? dayjs(date).format(format) : "";
}



// WEBPACK FOOTER //
// ./src/utils/formatDate.js